import _ from 'lodash';
import api from '@/api';

export default {
    namespaced: true,
    state: {
        alumnos: [],
        totalAlumnos: 0,
        academicos: [],
        totalAcademicos: 0,
    },
    getters: {
        alumnos: state => state.alumnos,
        totalAlumnos: state => state.totalAlumnos,
        academicos: state => state.academicos,
        totalAcademicos: state => state.totalAcademicos,
    },
    mutations: {
        SET_ALUMNOS(state, alumnos) {
            state.alumnos = alumnos;
        },
        SET_TOTAL_ALUMNOS(state, total) {
            state.totalAlumnos = !isNaN(total) ? parseInt(total) : 0;
        },
        SET_ACADEMICOS(state, academicos) {
            state.academicos = academicos;
        },
        SET_TOTAL_ACADEMICOS(state, total) {
            state.totalAcademicos = !isNaN(total) ? parseInt(total) : 0;
        },
    },
    actions: {
        getAlumnos: ({ commit }, { offset, limit, orderBy, desc, query }) => {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async function(resolve, reject) {
                const response = await api.get('/alumnos', {
                    params: { offset, limit, orderBy, desc, query },
                });

                if (response.status !== 200 && response.data) {
                    return reject(response.data.reason);
                }
                const alumnos = _.get(response, 'data.alumnos') || [];
                const total = _.get(response, 'data.total') || 0;
                commit('SET_ALUMNOS', alumnos);
                commit('SET_TOTAL_ALUMNOS', total);
                resolve();
            });
        },
        getAcademicos: (
            { commit },
            { offset, limit, orderBy, desc, query }
        ) => {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async function(resolve, reject) {
                const response = await api.get('/academicos', {
                    params: { offset, limit, orderBy, desc, query },
                });

                if (response.status !== 200 && response.data) {
                    return reject(response.data.reason);
                }
                const academicos = _.get(response, 'data.academicos') || [];
                const total = _.get(response, 'data.total') || 0;
                commit('SET_ACADEMICOS', academicos);
                commit('SET_TOTAL_ACADEMICOS', total);
                resolve();
            });
        },
    },
};
